<template>
  <div class="examination-experience coming-soon">
    <page-header title="我的备考心得" style="margin-bottom: 20px;" />

    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="标题">
        <el-input v-model="form.name" placeholder="请输入标题" />
      </el-form-item>
      <el-form-item label="视频链接">
        <el-input v-model="form.region" placeholder="请输入视频链接" />
      </el-form-item>
      <el-form-item label="备考心得">
        <el-input
          v-model="form.delivery"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8}"
          placeholder="请输入备考心得"
        />

      </el-form-item>
      <el-form-item label="半身照">
        <el-upload
          class="avatar-uploader"
          action="https://jsonplaceholder.typicode.com/posts/"
          :show-file-list="false"
        >
          <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon" />
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader'
import { ref } from 'vue'

const form = ref({})

</script>

<style lang="scss" scoped>
  .avatar-uploader{
    width: 180px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
